import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { style: {"padding-top":"130px"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 text-right" }
const _hoisted_5 = { class: "dropdown d-inline-block mr-1" }
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_11 = {
  class: "form-inline my-2 my-lg-0 mr-2",
  role: "search"
}
const _hoisted_12 = { class: "input-group input-group-sm" }
const _hoisted_13 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = {
  class: "text-primary font-weight-bold dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_16 = {
  class: "dropdown-menu",
  style: {"max-height":"250px","overflow-y":"auto"}
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "card mt-2" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "card-title" }
const _hoisted_22 = {
  key: 0,
  class: "fa fa-lock text-danger",
  title: "Survey is closed"
}
const _hoisted_23 = {
  key: 1,
  class: "fa fa-unlock-alt text-success",
  title: "Survey is open"
}
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "card-text"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col text-nowrap" }
const _hoisted_29 = { class: "text-primary" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col text-nowrap" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col text-nowrap" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "btn btn-sm btn-outline-secondary mr-1" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "dropdown d-inline-block" }
const _hoisted_39 = { class: "dropdown-menu" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstimationsPanelEditor = _resolveComponent("EstimationsPanelEditor")!
  const _component_AttributesSelector = _resolveComponent("AttributesSelector")!
  const _component_PanelAlternativesManager = _resolveComponent("PanelAlternativesManager")!
  const _component_PanelOpener = _resolveComponent("PanelOpener")!
  const _component_SurveyAccessLinks = _resolveComponent("SurveyAccessLinks")!
  const _component_PanelCloser = _resolveComponent("PanelCloser")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.panelEditor)
      ? (_openBlock(), _createBlock(_component_EstimationsPanelEditor, _mergeProps({ key: 0 }, _ctx.panelEditor, {
          onCreatePanel: _ctx.handleCreatePanelCommand,
          onUpdatePanel: _ctx.handleUpdatePanelCommand,
          onDeletePanel: _ctx.handleDeletePanelCommand,
          onClose: _ctx.closePanelEditor
        }), null, 16 /* FULL_PROPS */, ["onCreatePanel", "onUpdatePanel", "onDeletePanel", "onClose"]))
      : _createCommentVNode("v-if", true),
    (_ctx.attributesManager != null)
      ? (_openBlock(), _createBlock(_component_AttributesSelector, _mergeProps({ key: 1 }, _ctx.attributesManager, {
          onClose: _ctx.closeAttributesManager,
          onSave: _ctx.handleUpdatePanelAttributesSettingsCommand
        }), null, 16 /* FULL_PROPS */, ["onClose", "onSave"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_PanelAlternativesManager, {
      viewModel: _ctx.panelAlternativesManager,
      onSave: _ctx.handleUpdatePanelAlternativesSettingsCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSave"]),
    _createVNode(_component_PanelOpener, {
      viewModel: _ctx.panelOpener,
      onOpenPanel: _ctx.handleOpenPanelAccessCommand,
      onShowLinks: _ctx.showAccessLinks
    }, null, 8 /* PROPS */, ["viewModel", "onOpenPanel", "onShowLinks"]),
    _createVNode(_component_SurveyAccessLinks, {
      viewModel: _ctx.surveyAccessLinks,
      onSendEmail: _ctx.handleSendEmailCommand,
      onDownloadLinks: _ctx.downloadLinks
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail", "onDownloadLinks"]),
    _createVNode(_component_PanelCloser, {
      viewModel: _ctx.panelCloser,
      onCloseAccess: _ctx.handleClosePanelAccessCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCloseAccess"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PortfolioOrDecisionNavigation, {
        workspaceId: _ctx.workspaceId,
        projectId: _ctx.projectId
      }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-lg-6" }, [
            _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Assessments")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("button", {
                class: "btn btn-outline-secondary dropdown-toggle",
                type: "button",
                "data-toggle": "dropdown",
                style: {"padding":"0.7em 2em"}
              }, " Export to xls ", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadVotes && _ctx.downloadVotes(...args)))
                }, "Votes"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadDisagreements && _ctx.downloadDisagreements(...args)))
                }, "Disagreements")
              ])
            ]),
            _createElementVNode("button", {
              role: "button",
              class: "btn btn-success mr-1",
              style: {"padding":"0.7em 2em"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSurveyCreator && _ctx.showSurveyCreator(...args)))
            }, "Create panel"),
            _cache[6] || (_cache[6] = _createElementVNode("a", {
              class: "btn btn-outline-secondary btn-lg",
              href: "https://www.transparentchoice.com/user-guide/scoring",
              title: "User guide: Score projects",
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info",
                "aria-hidden": "true"
              })
            ], -1 /* CACHED */))
          ])
        ])
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.initialized)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
              _createTextVNode(" Loading...", -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true),
        (_ctx.initialized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("nav", _hoisted_10, [
                _createElementVNode("form", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control form-control-sm",
                      type: "search",
                      placeholder: "Search",
                      "aria-label": "Search",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        _ctx.SearchPhrase,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-append" }, [
                      _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("i", {
                          class: "fa-solid fa-magnifying-glass",
                          "aria-hidden": "true"
                        })
                      ])
                    ], -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("form", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[13] || (_cache[13] = _createTextVNode(" Filter by: ", -1 /* CACHED */)),
                    _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.FilterByOwnerLabel), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("a", {
                        class: "dropdown-item my-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setOwnerFilter(null)))
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("span", null, "All owners", -1 /* CACHED */)
                      ]))]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WorkspaceMembers, (m) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item my-2",
                          onClick: ($event: any) => (_ctx.setOwnerFilter(m.Email))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(m.Name), 1 /* TEXT */),
                          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", null, _toDisplayString(m.Email), 1 /* TEXT */),
                          _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */))
                        ], 8 /* PROPS */, _hoisted_17))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SurveysView, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s.SurveyId,
                    class: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("h5", _hoisted_21, [
                          (!s.SurveyStarted)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                            : (_openBlock(), _createElementBlock("i", _hoisted_23)),
                          _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */),
                          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", _hoisted_24, "Owner: " + _toDisplayString(_ctx.getOwnerName(s)), 1 /* TEXT */)
                        ]),
                        (s.IsSaving)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_25, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                              _createTextVNode(" Saving....", -1 /* CACHED */)
                            ]))]))
                          : _createCommentVNode("v-if", true),
                        (!s.IsSaving)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_29, [
                                    _createTextVNode(" Panelists: " + _toDisplayString(s.RespondentsCount), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, _ctx.url_AssessmentsPanelistsPage(s.SurveyId)]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("a", {
                                    class: "text-primary",
                                    onClick: ($event: any) => (_ctx.showAttributesManager(s))
                                  }, " Attributes: " + _toDisplayString(s.AttributesCount) + "/" + _toDisplayString(_ctx.TotalCriteriaCount), 9 /* TEXT, PROPS */, _hoisted_32)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("a", {
                                    class: "text-primary",
                                    onClick: ($event: any) => (_ctx.showPanelAlternativesManager(s))
                                  }, _toDisplayString(_ctx.AlternativesLabel) + ": " + _toDisplayString(s.AlternativesViewName), 9 /* TEXT, PROPS */, _hoisted_35)
                                ])
                              ]),
                              _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_36, [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("Review", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, _ctx.url_AssessmentsMeetingManagerPage(s.SurveyId)]
                              ]),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.handleUpdateAlternativesCommand(s)),
                                class: "btn btn-sm btn-outline-secondary mr-1"
                              }, "Save scores", 8 /* PROPS */, _hoisted_37),
                              _createElementVNode("div", _hoisted_38, [
                                _cache[19] || (_cache[19] = _createElementVNode("button", {
                                  class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                                  type: "button",
                                  "data-toggle": "dropdown"
                                }, " Actions ", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.showSurveyEditor(s))
                                  }, "Edit", 8 /* PROPS */, _hoisted_40),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.handleClonePanelCommand(s))
                                  }, "Clone", 8 /* PROPS */, _hoisted_41),
                                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  (!s.SurveyStarted)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.showPanelOpener(s.SurveyId))
                                      }, "Open survey", 8 /* PROPS */, _hoisted_42))
                                    : _createCommentVNode("v-if", true),
                                  (s.SurveyStarted)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.showPanelCloser(s.SurveyId))
                                      }, "Close survey", 8 /* PROPS */, _hoisted_43))
                                    : _createCommentVNode("v-if", true),
                                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.deletePanel(s))
                                  }, "Delete", 8 /* PROPS */, _hoisted_44)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}